unit Essentials.Web.Attributes.EditAttributeDefinitionForm;

interface

uses
  {$IFNDEF PAS2JS}
  Winapi.Windows, Winapi.Messages,
  {$ENDIF}
  System.SysUtils, {$IFNDEF PAS2JS}System.Variants,{$ENDIF} System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, Essentials.Web.BaseEditForm, Data.DB,
  WEBLib.DB, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, Essentials.Web.Shared;

type
  TEditAttributeDefinition = class(TEssentialsBaseEditForm)
    AttributeMultiValueCheckbox: TDBCheckBox;
    AttributeNameEdit: TDBEdit;
    AttributeValueKindComboBox: TDBComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure AttributeNameEditExit(Sender: TObject);
    procedure AttributeValueKindComboBoxChange(Sender: TObject);
  private
    { Private declarations }
    procedure SetEditMode(const Value: TEditMode); override;
    procedure LoadValueKindList;
  protected
    function AllRequiredFieldsAreSet: Boolean; override;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EditAttributeDefinition: TEditAttributeDefinition;

implementation

uses TypInfo, Essentials.Shared;

{$R *.dfm}

{ TEssentialsBaseEditForm1 }

function TEditAttributeDefinition.AllRequiredFieldsAreSet: Boolean;
begin
  Result := (AttributeNameEdit.Text <> '') and (AttributeValueKindComboBox.ItemIndex > -1);
end;

procedure TEditAttributeDefinition.AttributeNameEditExit(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TEditAttributeDefinition.AttributeValueKindComboBoxChange(
  Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TEditAttributeDefinition.LoadValueKindList;
var
  i: TsxeValueType;
begin
  AttributeValueKindComboBox.Items.Clear;

  for i := Low(TsxeValueType) to High(TsxeValueType) do
    AttributeValueKindComboBox.Items.Add(GetEnumName(TypeInfo(TsxeValueType), Ord(i)));
end;

procedure TEditAttributeDefinition.SetEditMode(const Value: TEditMode);
begin
  inherited;
  if FEditMode <> None then
  begin
    AttributeMultiValueCheckbox.Enabled := True;
    AttributeNameEdit.Enabled := True;
    AttributeValueKindComboBox.Enabled := True;
    AttributeNameEdit.SetFocus;
  end;
end;

procedure TEditAttributeDefinition.WebFormCreate(Sender: TObject);
begin
  inherited;
  AttributeMultiValueCheckbox.Enabled := False;
  AttributeNameEdit.Enabled := False;
  AttributeValueKindComboBox.Enabled := False;

  LoadValueKindList;
end;

procedure TEditAttributeDefinition.LoadDFMValues;
begin
  inherited LoadDFMValues;

  AttributeMultiValueCheckbox := TDBCheckBox.Create('essentials.attributes.multi.checkbox');
  AttributeNameEdit := TDBEdit.Create('essentials.attributes.name.edit');
  AttributeValueKindComboBox := TDBComboBox.Create('essentials.attributes.valuekind.selector');

  TitleBarLabel.BeforeLoadDFMValues;
  AttributeMultiValueCheckbox.BeforeLoadDFMValues;
  AttributeNameEdit.BeforeLoadDFMValues;
  AttributeValueKindComboBox.BeforeLoadDFMValues;
  try
    Height := 176;
    Caption := 'EditAttributeDefinition';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    TitleBarLabel.Width := 125;
    TitleBarLabel.Caption := 'Edit Attribute Definition';
    AttributeMultiValueCheckbox.SetParentComponent(Self);
    AttributeMultiValueCheckbox.Name := 'AttributeMultiValueCheckbox';
    AttributeMultiValueCheckbox.Left := 367;
    AttributeMultiValueCheckbox.Top := 105;
    AttributeMultiValueCheckbox.Width := 232;
    AttributeMultiValueCheckbox.Height := 22;
    AttributeMultiValueCheckbox.Caption := 'Allow Multiple Instances';
    AttributeMultiValueCheckbox.ChildOrder := 12;
    AttributeMultiValueCheckbox.ElementClassName := 'custom-control custom-checkbox';
    AttributeMultiValueCheckbox.ElementButtonClassName := 'custom-control-input';
    AttributeMultiValueCheckbox.ElementLabelClassName := 'custom-control-label';
    AttributeMultiValueCheckbox.ElementFont := efCSS;
    AttributeMultiValueCheckbox.ElementPosition := epIgnore;
    AttributeMultiValueCheckbox.HeightStyle := ssAuto;
    AttributeMultiValueCheckbox.HeightPercent := 100.000000000000000000;
    AttributeMultiValueCheckbox.WidthStyle := ssAuto;
    AttributeMultiValueCheckbox.WidthPercent := 100.000000000000000000;
    AttributeMultiValueCheckbox.DataField := 'MultiValue';
    AttributeMultiValueCheckbox.DataSource := DataSource;
    AttributeNameEdit.SetParentComponent(Self);
    AttributeNameEdit.Name := 'AttributeNameEdit';
    AttributeNameEdit.Left := 72;
    AttributeNameEdit.Top := 104;
    AttributeNameEdit.Width := 121;
    AttributeNameEdit.Height := 22;
    AttributeNameEdit.ChildOrder := 3;
    AttributeNameEdit.ElementClassName := 'form-control';
    AttributeNameEdit.ElementFont := efCSS;
    AttributeNameEdit.ElementPosition := epIgnore;
    AttributeNameEdit.HeightStyle := ssAuto;
    AttributeNameEdit.HeightPercent := 100.000000000000000000;
    AttributeNameEdit.Text := 'Name';
    AttributeNameEdit.WidthStyle := ssAuto;
    AttributeNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(AttributeNameEdit, Self, 'OnExit', 'AttributeNameEditExit');
    AttributeNameEdit.DataField := 'Name';
    AttributeNameEdit.DataSource := DataSource;
    AttributeValueKindComboBox.SetParentComponent(Self);
    AttributeValueKindComboBox.Name := 'AttributeValueKindComboBox';
    AttributeValueKindComboBox.Left := 199;
    AttributeValueKindComboBox.Top := 104;
    AttributeValueKindComboBox.Width := 145;
    AttributeValueKindComboBox.Height := 23;
    AttributeValueKindComboBox.ElementClassName := 'form-select';
    AttributeValueKindComboBox.ElementFont := efCSS;
    AttributeValueKindComboBox.HeightStyle := ssAuto;
    AttributeValueKindComboBox.HeightPercent := 100.000000000000000000;
    AttributeValueKindComboBox.Text := 'Value Kind';
    AttributeValueKindComboBox.WidthPercent := 100.000000000000000000;
    SetEvent(AttributeValueKindComboBox, Self, 'OnChange', 'AttributeValueKindComboBoxChange');
    AttributeValueKindComboBox.ItemIndex := -1;
    AttributeValueKindComboBox.DataField := 'ValueKind';
    AttributeValueKindComboBox.DataSource := DataSource;
  finally
    TitleBarLabel.AfterLoadDFMValues;
    AttributeMultiValueCheckbox.AfterLoadDFMValues;
    AttributeNameEdit.AfterLoadDFMValues;
    AttributeValueKindComboBox.AfterLoadDFMValues;
  end;
end;

end.
